import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalCourseStore from '../../../../../stores/global-course-store';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const deleteExamOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number | undefined,
) => {
  try {
    if (!programId || !courseId || !examId) {
      toast.warn(
        'לא ניתן לזהות את מזהה הקורס ו/או השולוחה, נסה שוב בעוד מספר רגעים',
      );
      return;
    }

    const res = await appApi.deleteExam(programId, courseId, examId);

    if (res.data.ok) {
      globalCourseStore.updateCourseDetails(
        courseId,
        res.data.body.metadata,
        res.data.body.details,
      );
    } else if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  }
};
